import { render, staticRenderFns } from "./RecentLeadsModal.vue?vue&type=template&id=801cbd70&scoped=true&"
import script from "./RecentLeadsModal.vue?vue&type=script&lang=js&"
export * from "./RecentLeadsModal.vue?vue&type=script&lang=js&"
import style0 from "./RecentLeadsModal.vue?vue&type=style&index=0&id=801cbd70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801cbd70",
  null
  
)

export default component.exports